import { SorterTypes } from '@shared/filters/entities/sorter-options';

export const SORT_FLIGHTS_CLASS = {
  [SorterTypes.Recommended]: 'recommended',
  [SorterTypes.Price]: 'lowest-price',
  [SorterTypes.Duration]: 'lowest-duration',
};

export const SORTER_TITLES = {
  [SorterTypes.Recommended]: 'PRODUCT_FILTERS.SORTER.RECOMMENDED',
  [SorterTypes.Price]: 'PRODUCT_FILTERS.SORTER.LOWEST_PRICE',
  [SorterTypes.Duration]: 'PRODUCT_FILTERS.SORTER.LOWEST_DURATION',
  [SorterTypes.Departure]: 'PRODUCT_FILTERS.SORTER.DEPARTURE',
  [SorterTypes.Arrival]: 'PRODUCT_FILTERS.SORTER.ARRIVAL'
};

const EARLIEST_DEPARTURE = 'PRODUCT_FILTERS.SORTER.EARLIEST_DEPARTURE';
const LAST_DEPARTURE = 'PRODUCT_FILTERS.SORTER.LAST_DEPARTURE';
const EARLIEST_ARRIVAL = 'PRODUCT_FILTERS.SORTER.EARLIEST_ARRIVAL';
const LAST_ARRIVAL = 'PRODUCT_FILTERS.SORTER.LAST_ARRIVAL';

export const SORTER_BY_AUX_CRITERIA_TYPE = {
  EARLIEST_DEPARTURE_1: EARLIEST_DEPARTURE,
  LAST_DEPARTURE_1: LAST_DEPARTURE,
  EARLIEST_DEPARTURE_2: EARLIEST_DEPARTURE,
  LAST_DEPARTURE_2: LAST_DEPARTURE,
  EARLIEST_ARRIVAL_1: EARLIEST_ARRIVAL,
  LAST_ARRIVAL_1: LAST_ARRIVAL,
  EARLIEST_ARRIVAL_2: EARLIEST_ARRIVAL,
  LAST_ARRIVAL_2: LAST_ARRIVAL,
};
